import tw from "twin.macro"

export const Wrapper = tw.div`
  flex justify-center my-3
`
